<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>처방 문답</h2>
      </div>

      <article class="view cmnity">
        <div class="search_box" style="flex-wrap: wrap">
          <p class="w100 mb20">
            총
            <strong> {{ formulaQnaList.length }} </strong>건
          </p>
          <div class="flex items-center justify-between w100">
            <div class="form_inline">
              <span class="mw100 fwb">처방 문의 내용</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.inquiry_details"
              />
              <span class="mw100 fwb ml10">주소증</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.chief_complaint"
              />
            </div>
            <div class="form_inline">
              <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
              <button
                class="btn btn_md btn_brown"
                @click="fn_move_regPage"
              >
                처방문답 등록
              </button>
            </div>
          </div>
          <div class="flex items-center justify-between w100 mt10">
              <div class="form_inline">
                  <span class="mw100 fwb">카테고리</span>
                  <div class="form_select">
                    <b-form-select v-model="searchInfo.prescribe_category" style="width: 310px">
                      <b-form-select-option value="">선택</b-form-select-option>
                      <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                    </b-form-select>
                  </div>
              </div>
          </div>
        </div>
        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <colgroup>
                  <col width="150" />
                  <col width="*" />
                  <col width="200" />
                  <col width="100" />
                  <col width="*" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>카테고리</th>
                    <th>처방문의</th>
                    <th>환자나이</th>
                    <th>환자성별</th>
                    <th>주소증</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="formulaQnaList.length == 0">
                      <td colspan="5"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr
                    v-for="(item, index) in formulaQnaList"
                    :key="index"
                    @click="fn_move_dtl_page(item.formula_inquiry_seq)"
                  >
                    <td>
                      <span>{{ searchInfo.pageInfo.totPage - ( (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize) - index}}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_category_nm }}</span>
                    </td>
                    <td class="al">
                      <span>{{ item.inquiry_details }}</span>
                    </td>
                    <td>
                      <span>{{ item.age }}</span>
                    </td>
                    <td>
                      <span>{{ item.gender_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.chief_complaint }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="movePage" v-show="pagingShow"/>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
  import axios from 'axios'
  import Pagination from "@/components/AdminPagination.vue"
  import AlertModal from "@/modal/common/alertModal.vue"
  import alertutill from "@/mixin/alertModalUtill";
  import commonUtil from "@/mixin/commonUtil";

export default {
  components: {
    Pagination,
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      clinicDoctorId : '',
      searchInfo : {
          inquiry_details : '',
          chief_complaint : '',
          prescribe_category : '',
          pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
          }                
      },
      pagingShow : false,
      formulaQnaList: [],
      prescrbeCategoryList : []

    };
  },
  async created(){
    //처방 카테고리
    this.prescrbeCategoryList = await this.getCode('GC00000015'); 
  },
  mounted(){
      this.fn_search();
  },
  methods : {
    fn_search(){
        axios
            .post("/api/user/board/getformulaQnaList", this.searchInfo)
            .then((res) => {

                this.formulaQnaList = res.data.formulaQnaList;
                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                }                        

            })
            .catch((err) => console.log(err));
    },
    movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
    },
    fn_move_regPage(){
        this.$router.push("/formulaQnaWrite");
    },
    fn_move_dtl_page(seq){
        this.$store.dispatch('detailSearchInfo/setSearchId', seq); 
        this.$router.push({ name : 'FormulaQnaDetail'});
    },
  }
};
</script>
